var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-y": "",
        "min-width": "290px",
        disabled: _vm.disabled || _vm.readonly,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    attrs: {
                      label: _vm.label,
                      readonly: "",
                      disabled: _vm.disabled,
                      "prepend-icon": "event",
                      dense: _vm.dense,
                    },
                    model: {
                      value: _vm.formatedDates,
                      callback: function ($$v) {
                        _vm.formatedDates = $$v
                      },
                      expression: "formatedDates",
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c("v-date-picker", {
        attrs: {
          range: "",
          "no-title": "",
          color: "primary",
          disabled: _vm.disabled,
          dense: _vm.dense,
        },
        model: {
          value: _vm.dates,
          callback: function ($$v) {
            _vm.dates = $$v
          },
          expression: "dates",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }